import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { SystemModel, UCSystemType, Side, UpdateComponentMeasurementModel, MeasurementType, ComponentModel, QuoteOverviewModel } from '../../models/interpretation.model';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';import { AddRecommendationComponent } from '../add-recommendation/add-recommendation.component';
import { QuoteService } from '../../quote-service.service';
import { UserService } from '../../../../shared/services/user.service';
import { LoadingService } from '../../../../shared/services/loading.service';
import { AppService } from '../../../../../app/app.service';
import { SetupUndercarriageService } from '../../../../modules/setup-undercarriage';
import { TranslateService } from '../../../../translate';
import { CustomeEvaluationRangeVM } from '../../../../../app/modules/CustomEval/custom-eval.model';
import { TrackFrameConfigurationComponent } from '../.,/../../../../../app/modules/manage-equipment/components/track-frame-configuration/track-frame-configuration.component';
import { MultiplePhotoUploadComponent } from '../multiple-photo-upload/multiple-photo-upload.component';
import { EditSystemSerialNumberComponent } from '../edit-system-serial-number/edit-system-serial-number.component';

@Component({
  selector: 'app-forecast-interpretation',
  templateUrl: './forecast-interpretation.component.html',
  styleUrls: ['./forecast-interpretation.component.scss']
})
export class ForecastInterpretationComponent implements OnInit, AfterViewInit {
  @Input() inspectionId: number = -1;
  @Input() systemId: number = -1;
  @Input() selectedQuoteId: number = -1;

  @Input() Family_:string
  @Input() FamilyImage_Frame:string

  @Input() FamilyImage_Chain:string

  @Input() equipmentID:number;

updateComment: string;
  @Output() reloadSelectedQuote: EventEmitter<any> = new EventEmitter();

  @Output() measurementPointUpdated   =  new EventEmitter();
  quotes: QuoteOverviewModel[] = [];
  system: SystemModel = new SystemModel();
  loadingSystems = true;
  side = 'Left';
  type = 'Chain';
  isInspector = false;
  isInterpreter = false;

  _inspectionId: number = -1;
  overallEval = 'U';
  overallEvalLoading = true;
  removeFlagPopup = false;
  userLanguage: string = "english";
  flag_comment:string="";
  flag_on:boolean=false;
  selected_inspection_detail_auto:number;
  selected_track_unit_auto:number;

  @Input() InspectionSMU: number;
  @Input() EvalautionRange:CustomeEvaluationRangeVM;
  constructor(
    private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _sanitizer: DomSanitizer,
    private _dialog: MatDialog,
    private _quotes: QuoteService,
    private _cdr: ChangeDetectorRef,
    private _user: UserService,
    private _appService: AppService,
    private _loading: LoadingService,
    private _setupService: SetupUndercarriageService,
    private _translate: TranslateService,
    private _app: AppService,
    
    ) { }

  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case 'Inspectors':
              this.isInspector = true;
              break;
            case 'Interpreters':
            case 'Super User':
            case 'Administrator':
              this.isInterpreter = true;
              this.isInspector = true;
              break;
              case 'Customer Admin':
                this.isInspector = true;
              this.isInterpreter = true;
                break;
          }
        });
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );
  }
  UTEquivalenetEnabled:boolean=false;
  UTEqu:string;
  isEnableMaxRange:boolean;
  ngOnInit() {
    this.checkPermissions();
    this.loadSystem();
    this.loadQuotes();
    this._app.getApplicationConfigValue("UTEquivalentEnabled").subscribe(result => {
      this.UTEqu = result
      if (this.UTEqu == "1") {
          this.UTEquivalenetEnabled = true;

      } else {
          this.UTEquivalenetEnabled = false;
      }

  });


  this._app.getApplicationConfigValue("EnableMaxRangeForEvaluation").subscribe(result => {
    
    if (result == "1") {
        this.isEnableMaxRange = true;
    } else {
        this.isEnableMaxRange = false;
    }
});

  }

  

  ngAfterViewInit() {
    // this._cdr.detach();
  }

//
  GetEvalColour(comp: ComponentModel, worn: number) {
    var compType = comp.ComponentTypeId;

    if(comp.Measurement==-1){
      return 'Eval-U';
    }
    switch (compType) {
      case 230: //Link
        if (this.EvalautionRange.LinkC != null) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

        case 231://Bush
          if (this.EvalautionRange.BushC != null) {
            if (worn <= this.EvalautionRange.BushA)
              return 'Eval-A';
            else if (worn <= this.EvalautionRange.BushB)
              return 'Eval-B';
            else if (worn <= this.EvalautionRange.BushC)
              return 'Eval-C';
            else
              return 'Eval-X';
          } else {
            if (worn <= this.EvalautionRange.BushA)
              return 'Eval-A';
            else if (worn <= this.EvalautionRange.BushB)
              return 'Eval-B';
            else
              return 'Eval-X';
          }
        
          case 232: //Shoe
            if (this.EvalautionRange.ShoeC != null) {
              if (worn <= this.EvalautionRange.ShoeA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.ShoeB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.ShoeC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.ShoeA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.ShoeB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 233://Idler
            if (this.EvalautionRange.LinkC != null) {
              if (worn <= this.EvalautionRange.LinkA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.LinkB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.LinkC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.LinkA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.LinkB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 234://carrier Roller
            if (this.EvalautionRange.CarrierRollerC != null) {
              if (worn <= this.EvalautionRange.CarrierRollerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.CarrierRollerB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.CarrierRollerC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.CarrierRollerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.CarrierRollerB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 235://track Roller
            if (this.EvalautionRange.TrackRollerC != null) {
              if (worn <= this.EvalautionRange.TrackRollerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.TrackRollerB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.TrackRollerC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.TrackRollerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.TrackRollerB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }
            case 236://Sprokcket
            if (this.EvalautionRange.SprocketC != null) {
              if (worn <= this.EvalautionRange.SprocketA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.SprocketB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.SprocketC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.SprocketA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.SprocketB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 240://Elognation
            if (this.EvalautionRange.ElongationC != null) {
              if (worn <= this.EvalautionRange.ElongationA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.ElongationB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.ElongationC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.ElongationA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.ElongationB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 417://Crawler
            if (this.EvalautionRange.CrawlerGuideC != null) {
              if (worn <= this.EvalautionRange.CrawlerGuideA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.CrawlerGuideB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.CrawlerGuideC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.CrawlerGuideA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.CrawlerGuideB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }

            case 446://RSREAR
            if (this.EvalautionRange.RSRearIdlerC != null) {
              if (worn <= this.EvalautionRange.RSRearIdlerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.RSRearIdlerB)
                return 'Eval-B';
              else if (worn <= this.EvalautionRange.RSRearIdlerC)
                return 'Eval-C';
              else
                return 'Eval-X';
            } else {
              if (worn <= this.EvalautionRange.RSRearIdlerA)
                return 'Eval-A';
              else if (worn <= this.EvalautionRange.RSRearIdlerB)
                return 'Eval-B';
              else
                return 'Eval-X';
            }
            case 237://Idler
           
              if (worn <= 30)
                return 'Eval-A';
              else if (worn <= 50)
                return 'Eval-B';
              else if (worn <= 70)
                return 'Eval-C';
              else
                return 'Eval-X';
            

      default:
        break;
    }
  }


  viewComponentPhoto(photoId: number, inspectionDetailId:number,component:ComponentModel) {
    //console.log("id__1",photoId)
    //const viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
      const viewPhotoModalRef = this._dialog.open(MultiplePhotoUploadComponent, {
        width: '800px',
      
      data: {
        inspectionId: this.inspectionId,
        photoId: photoId,
        inspectionDetailId:inspectionDetailId
      }
    });
    viewPhotoModalRef.afterClosed().subscribe(reloadPhoto => {
      if (reloadPhoto)
        this.loadPhoto(component)//this.loadSystem();
    });
  }

  openAddRecommendation(componentId: number) {
    const addRecommendationModalRef = this._dialog.open(AddRecommendationComponent, {
      data: {
        inspectionId: this.inspectionId,
        componentId: componentId,
        quoteId: this.selectedQuoteId,
        inspectionSMU: this.InspectionSMU,
      }
    });
    addRecommendationModalRef.afterClosed().subscribe(details => {
      if (details != null) {
        this._quotes.reloadQuoteOverview(this.inspectionId);
        this.loadSystem();
        this.reloadSelectedQuote.emit(details)
      }
    });
  }
  openTrackCofiguration(selectedType:number,selectedValue:number,systemId:number,Side:number) {
    const dialogRef = this._dialog.open(TrackFrameConfigurationComponent, {
      disableClose: true,
      width: '1032px',
        data: {
            selectedType:selectedType,
            selectedValue:selectedValue,
            systemId:systemId,
            equipmentId:this.equipmentID
        }
    });

    dialogRef.afterClosed().subscribe(res => {
      //console.log("system", this.system)
     
      if(selectedType==1){
        this.system.ToeOutFrame = res;
        if(selectedValue!=res){
          //need to update 
        }
        //console.log("system__", this.system)
      }else{
        this.system.CastFrame = res;
        if(selectedValue!=res){
          //need to update 
        }
        //console.log("system++++", this.system)
      }

      
    });
}
  loadSystem() {
    this._interp.getSystem(this.inspectionId, this.systemId).subscribe(system => {
      console.log("s",system)
      this.system = system;
      this.loadingSystems = false;
      this._cdr.detectChanges();
      this.measurementPointUpdated.emit();


      this.system.Components.map(x=>{
        if(x.ComponentTypeId==230){
          if(this.EvalautionRange.LinkC==null)  x.isExcludeC=true;
          else x.isExcludeC=false;


          if(x.Tool=="Eval"){
            console.log("EVALLL____")
            this.changeEval_(x.EvalCode, x.InspectionDetailId,x.ComponentTypeId);
          }
        
        }
        if(x.ComponentTypeId==231){
          if(this.EvalautionRange.BushC==null) x.isExcludeC=true;
          else x.isExcludeC=false;

          if(x.Tool=="Eval"){
            this.changeEval_(x.EvalCode, x.InspectionDetailId,x.ComponentTypeId);
          }
        }
        if(x.ComponentTypeId==232){
          if(this.EvalautionRange.ShoeC==null) x.isExcludeC=true;
          else x.isExcludeC=false;

          if(x.Tool=="Eval"){
            this.changeEval_(x.EvalCode, x.InspectionDetailId,x.ComponentTypeId);
          }
        }
        if(x.ComponentTypeId==233){
          if(this.EvalautionRange.IdlerC==null) x.isExcludeC=true;
          else x.isExcludeC=false;

          if(x.Tool=="Eval"){
            this.changeEval_(x.EvalCode, x.InspectionDetailId,x.ComponentTypeId);
          }
        }
        if(x.ComponentTypeId==234){
          if(this.EvalautionRange.CarrierRollerC==null) x.isExcludeC=true;
          else x.isExcludeC=false;

          if(x.Tool=="Eval"){
            this.changeEval_(x.EvalCode, x.InspectionDetailId,x.ComponentTypeId);
          }
        }
        if(x.ComponentTypeId==235){
          if(this.EvalautionRange.TrackRollerC==null) x.isExcludeC=true;
          else x.isExcludeC=false;

          if(x.Tool=="Eval"){
            this.changeEval_(x.EvalCode, x.InspectionDetailId,x.ComponentTypeId);
          }
        }
        if(x.ComponentTypeId==236){
          if(this.EvalautionRange.SprocketC==null) x.isExcludeC=true;
          else x.isExcludeC=false;

          if(x.Tool=="Eval"){
            this.changeEval_(x.EvalCode, x.InspectionDetailId,x.ComponentTypeId);
          }
        }
        if(x.ComponentTypeId==240){
          if(this.EvalautionRange.ElongationC==null) x.isExcludeC=true;
          else x.isExcludeC=false;

          if(x.Tool=="Eval"){
            this.changeEval_(x.EvalCode, x.InspectionDetailId,x.ComponentTypeId);
          }
        }
        if(x.ComponentTypeId==417){
          if(this.EvalautionRange.CrawlerGuideC==null) x.isExcludeC=true;
          else x.isExcludeC=false;

          if(x.Tool=="Eval"){
            this.changeEval_(x.EvalCode, x.InspectionDetailId,x.ComponentTypeId);
          }
        }
        if(x.ComponentTypeId==446){
          if(this.EvalautionRange.RSRearIdlerC==null) x.isExcludeC=true;
          else x.isExcludeC=false;

          if(x.Tool=="Eval"){
            this.changeEval_(x.EvalCode, x.InspectionDetailId,x.ComponentTypeId);
          }
        }

      })
    });

  }

  showPosition(position: number, compartTypeId: number): string {
    let hasSameComponent = this.system.Components.filter(x=>x.ComponentTypeId==compartTypeId && x.IsChild==false);
    if(hasSameComponent.length>1){
      return this.getPositionStringDoubleComponents(position,compartTypeId);
    }else{
      return this._app.getPositionString(position, compartTypeId);
    }
    // if(this.system.Components.length >4){
    //         return this.getPositionStringDoubleComponents(position,compartTypeId);
    // }else{
    //     return this._app.getPositionString(position, compartTypeId);
    // }
   
}

getPositionStringDoubleComponents(Pos: number, CompartTypeId: number): string {
  if (CompartTypeId === 233) // Idler
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
  if (CompartTypeId === 234 && Pos === 1) // Carrier roller
      return 'Front';
  if (CompartTypeId >= 230 && CompartTypeId <= 232 || CompartTypeId === 236 || CompartTypeId === 237 || CompartTypeId === 240 )
  {// Link, Bushing, Shoe, Sprocket
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
     
  } 
  if(CompartTypeId == 446)
      return 'Rear'
  return Pos.toString();
}
    
  changeEval(selectedEval: string, inspectionDetailId: number,compType:number) {
    //const measurement =  this._appService.getEvalToolMeasurementPoint(selectedEval);
    const measurement =  this._appService.getEvalToolMeasurementPoint_Worn(selectedEval,compType,this.EvalautionRange,this.isEnableMaxRange);
    //console.log("Measureemt", measurement)
    const m = new UpdateComponentMeasurementModel(this.inspectionId, inspectionDetailId, measurement, this.unitOfMeasurement, 9,this.EvalautionRange, null);
    this._interp.updateComponentMeasurement(m).subscribe(r => {
      if (r.m_Item1) {
        this.loadSystem();
        this.measurementPointUpdated.emit();
        this._notify.success('Updated', r.m_Item2);
      } else {
        this._notify.error('Failed', 'Unable to update component measurement. ');
        console.error(r.m_Item2);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to update component measurement. ');
      console.error(err);
    });
  }


  changeEval_(selectedEval: string, inspectionDetailId: number,compType:number) {
    //const measurement =  this._appService.getEvalToolMeasurementPoint(selectedEval);
    const measurement =  this._appService.getEvalToolMeasurementPoint_Worn(selectedEval,compType,this.EvalautionRange,this.isEnableMaxRange);
    //console.log("Measureemt", measurement)
    const m = new UpdateComponentMeasurementModel(this.inspectionId, inspectionDetailId, measurement, this.unitOfMeasurement, 9,this.EvalautionRange, null);
    this._interp.updateComponentMeasurement(m).subscribe(r => {
      if (r.m_Item1) {
        this.measurementPointUpdated.emit();
      
      } else {
       
      }
    }, err => {
    
      console.error(err);
    });
  }
  loadQuotes() {
    this._quotes.getQuoteOverviewsAndReloadIfFirst(this.inspectionId).subscribe(r => {
      this.quotes = r;
    });
  }

  loadComment(component:ComponentModel){
this._interp.GetComponentComment(this.inspectionId,component.InspectionDetailId).subscribe(res=>{
  if(res.m_Item1==true){
    component.Comment = res.m_Item2;
    this.updateComment = res.m_Item2;
  }
})
    component.Comment = this.updateComment;
   
  }

  loadPhoto(component:ComponentModel){
    this._interp.getComponentPhotoList(component.InspectionDetailId,this.inspectionId).subscribe(res=>{
      if(res.photo1!=null){
        component.PhotoThumbnail = res.photo1;
        //this.updateComment = res.m_Item2;
      }else{
        component.PhotoThumbnail = '';

      }
    })
        //component.Comment = this.updateComment;
       
  }

  componentHasRecommendation(componentId: number): boolean {
    const quote = this.quotes.find(q => q.QuoteId === this.selectedQuoteId);
    if (quote == null)
      return false;
    const recommendation = quote.Recommendations.find(q => q.ComponentId === componentId);
    if (recommendation != null)
      return true;
    return false;
  }

  get panelHeading() {
    if (this.loadingSystems)
      return '';
    return this.systemSide + ' Side ' + this.systemName;
  }
  getMeasurement(event: any,c:ComponentModel){
    //console.log("event__123 ", event.target.value)
    return c.Measurement;
  }
  /**
   * Updates a component measurement with the new measurement given.
   * Will reload the table with the data after saving successfully.
   * @param measurement The new measurement (in mm or inches, depending on the users preference)
   * @param inspectionDetailId The inspection detail id to update the measurement for
   */
  public updateComponentMeasurement(measurement: number, inspectionDetailId: number, event:any, component:ComponentModel) {
measurement = event.target.value;
    //console.log("event____11111", event.target.value)
    const m = new UpdateComponentMeasurementModel(this.inspectionId, inspectionDetailId, measurement, this.unitOfMeasurement, -1,this.EvalautionRange, null);

    this._interp.updateComponentMeasurement(m).subscribe(r => {
      if (r.m_Item1) {
        //this.loadSystem();
        //this.measurementPointUpdated.emit();
        this.loadSelectedComponentMeasurement(component,inspectionDetailId);
        this._notify.success('Updated', r.m_Item2);
      } else {
        this._notify.error('Failed', 'Unable to update component measurement. ');
        console.error(r.m_Item2);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to update component measurement. ');
      console.error(err);
    });
  }


  loadSelectedComponentMeasurement(component:ComponentModel,inspectionDetailsId:number){
    this._interp.GetComponentMeasurement(this.inspectionId, inspectionDetailsId).subscribe(res=>{
      if(res!=null){
        component.WornPercentage = res.WornPercentage;
        component.EvalCode=res.EvalCode;
        component.Measurement = res.Measurement;

        console.log("this.system", this.system.Components)
        
          this.system.Components.map(x=>{
            if(x.ComponentId == res.ParentComponentId){
              console.log("this.xx", x)
              x.WornPercentage  = res.ParentWornPercentage;
            }
          })
        
        
        //console.log(component)
      }
    })
  }
  //onPress flag
  onClickFlag(component){


    this.removeFlagPopup == false ? this.removeFlagPopup = true : this.removeFlagPopup = false

    this.flag_comment = component.flag_comment
    this.flag_on = component.flag_on
    this.selected_inspection_detail_auto = component.InspectionDetailId
    this.selected_track_unit_auto=component.ComponentId
  }

  onClickRemoveFlag(){
   

    this._interp.updateComponentFlag(this.inspectionId,this.selected_inspection_detail_auto, this.selected_track_unit_auto).subscribe(r => {
     
      this.removeFlagPopup = false 
      this.loadSystem();
      this.measurementPointUpdated.emit();
      this._notify.success('Flag Updated');
    }, err => {
      this._notify.error('Failed', 'Unable to update component measurement. ');
      console.error(err);
    });
  }

  onClickCloseFlag(){
    this.removeFlagPopup = false 
    this.flag_comment = ""
    this.flag_on =false
    this.selected_inspection_detail_auto = 0
    this.selected_track_unit_auto=0
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
}
  // load Overall Eval
  loadOverallEval() {
    this._interp.getOverallEval(this.inspectionId).subscribe(overallEval => {
      this.overallEval = overallEval;
      this.loadSystem();
    }, err => this.handleError(err, 'Can\'t get the overall evaluation. '));
  }


  public updateComponentTool(measurement: number, inspectionDetailId: number, toolId: number) {
    const m = new UpdateComponentMeasurementModel(this.inspectionId, inspectionDetailId, measurement, this.unitOfMeasurement, toolId,this.EvalautionRange, null);
    if ( toolId === 9 ) m.Measurement = 30;
    this._interp.updateComponentMeasurement(m).subscribe(r => {
      if (r.m_Item1) {
        this.loadSystem();
        this.measurementPointUpdated.emit();
        this._notify.success('Updated', r.m_Item2);
      } else {
        this._notify.error('Failed', 'Unable to update component measurement. ');
        console.error(r.m_Item2);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to update component measurement. ');
      console.error(err);
    });
  }

  get systemName(): string {
    switch (this.system.Type) {

      case UCSystemType.Chain:
        return 'Chain';
      case UCSystemType.Frame:
        return 'Frame';
      default:
        return 'Chain';
    }
  }

  /**
  * Gets the name of the side of the equipment that
  * this system is on.
  * @returns The side of the system.
  */
  get systemSide(): string {
    switch (this.system.Side) {
      case Side.Unknown: return 'Unknown';
      case Side.Both: return 'Both';
      case Side.Left: return 'Left';
      case Side.Right: return 'Right';
    }
  }

  /**
   * Gets the abbreviate unit of measurement the current user has
   * set. It is based off what they have selected in
   * their user preferences.
   * @returns The abbreviation of milimeters or inches.
   */
  get unitOfMeasurementShort(): string {
    switch (this.unitOfMeasurement) {
      case MeasurementType.Milimeter:
        return 'mm';
      case MeasurementType.Inch:
        return 'in';
      default:
        return '?';
    }
  }

  /**
   * Gets the current unit of measurement the logged in user
   * has set.
   */
  get unitOfMeasurement(): MeasurementType {
    if (this.system != null && this.system.Components.length > 0)
      return this.system.Components[0].MeasurementType;
    return MeasurementType.Milimeter;
  }

  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(image);
  }

  /**
   * Gets the component from the given Id.
   * @param componentId The ID component we want to get.
   * @returns The component model.
   */
  getComponent(componentId: number): ComponentModel {
    return this.system.Components.find(c => c.ComponentId === componentId);
  }

  /**
   * Determines if the child component row displayed in the table is in the first
   * position, somewhere in the middle of the list, or in the last position.
   * We need to know this so we can determine how to draw the lines that connect
   * the child components to the parent to indicate they are children to the user.
   * @param componentId The Id of the component we are drawing the row for.
   * @returns The css class extension to draw the correct line based on the position.
   */
  getChildRowPosition(componentId: number): string {
    const component = this.getComponent(componentId);
    const children = this.system.Components.filter(c => c.ComponentTypeId === component.ComponentTypeId && c.IsChild);
    if (children[0].ComponentId === componentId) return '--extended';
    if (children[children.length - 1].ComponentId === componentId) return '--half';
    return '';
  }

  /**
   * Checks if the given component Id is a parent component. Returns true if the component
   * is a parent.
   * @param componentId The id of the component we want to know is a parent or child.
   */
  isParent(componentId: number): boolean {
    const component = this.getComponent(componentId);
    const children = this.system.Components.filter(c => c.ComponentTypeId === component.ComponentTypeId && c.IsChild);
    if (children.length > 0) {
      const childrenWithParent = this.system.Components.filter(c => c.ComponentTypeId === component.ComponentTypeId);
      if (childrenWithParent[0].ComponentId === componentId) return true;
    }
    return false;
  }

  handleError(error, message: string) {
    this._notify.error('Error', message);
    console.error(error);
    this._loading.finishedLoading();
  }


  getImage_(image: string) {

    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }


  getFamilyDetails(value: string) {
    this._setupService.getFamilyList().subscribe(res => {
      if (res != null) {
        let familydetails = res
          familydetails.map(x => {
            if (x.typedesc == value) {
              this.FamilyImage_Chain = x.ChainImage
              this.FamilyImage_Frame = x.FrameImage
            }
          })
        }
    })
  }

  updateComponentComment(inspectionId:number, inspectionDetailId:number,comment:string){
    this._interp.updateComponentComment(this.inspectionId, inspectionDetailId, comment ).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.error('Failed', r.m_Item2, r.m_Item2);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to save comment. Please contact TrackTreads support. ', err);
    });
  }

  EditSerial(sys:SystemModel){
    const editSeralNumber = this._dialog.open(EditSystemSerialNumberComponent, {
      data: {
        SerialNumber: sys.SerialNumber,
        systemId: sys.Id,
      }
    });
    editSeralNumber.afterClosed().subscribe(details => {
      if (details ==true) {
        this._interp.GetSystemSerial(sys.Id).subscribe(res=>{
          sys.SerialNumber = res;
        })
        //this._quotes.reloadQuoteOverview(this.inspectionId);
        //this.loadSystem();
        //this.reloadSelectedQuote.emit(details)
      }
    });
  }
}

